<template>
  <div>
    <div class="popular plr" v-if="categories">
      <div class="popular_head">
        <div class="category_title">
          <BackButton
            v-if="this.$store.getters.outlet.slider.cards.length !== 0 || this.$store.getters.categories.length > 3"
          />
          <div class="ti">{{$store.getters.selectedCategory ? $store.getters.selectedCategory.name : ''}}</div>
        </div>  
      </div>
      <CategoryList :categories="categories"/>
    </div>

    <div class="search_tovar plr"
         v-if="$store.getters.selectedCategory && $store.getters.selectedCategory.id !== null && ($store.getters.loading[FETCH_PRODUCTS] || products.length)">
      <div class="popular_head">
        <!--                <div class="ti">Товары</div>-->
        <!--                <a class="view_all tovar_filtr" href="#">Фильтр</a>-->
      </div>

      <ProductList :products="products"
                   :mode="this.$store.getters.selectedCategory && this.$store.getters.selectedCategory.id === 0 ? MODE_POPULAR : MODE_CATEGORY"/>
    </div>
  </div>
</template>

<script>
  import {FETCH_PRODUCTS} from '@/store/actions.type'
  import PopularProducts from '@/components/ECommerce/Products/PopularProducts'
  import CategoriesPreview from '@/components/ECommerce/Categories/CategoriesPreview'
  import CategoryList from '@/components/ECommerce/Categories/CategoryList'
  import BackButton from '@/components/ECommerce/Categories/BackButton'
  import {SET_SELECTED_CATEGORY} from '@/store/mutations.type'
  import ProductList from '@/components/ECommerce/Products/ProductList'
  import * as moment from 'moment'

  const MODE_CATEGORY = 0
  const MODE_POPULAR = 1
  const MODE_SEARCH = 2

  export default {
    name: 'CategoryView',
    data() {
      return {
        FETCH_PRODUCTS,

        MODE_CATEGORY, MODE_POPULAR, MODE_SEARCH
      }
    },
    components: {
      ProductList,
      CategoryList,
      CategoriesPreview,
      BackButton,
      PopularProducts
    },
    methods: {
      handleScroll() {
        let element = document.getElementsByClassName('nav_line_main')[0]
        if (element) {
          if (window.scrollY < 170) {
            element.classList.remove('nav_line_main_act')
          } else {
            element.classList.add('nav_line_main_act')
          }
        }
      },

      filtered(product) {
        if (this.$store.getters.outletSettings.delivery_type !== 4) {

        } else {

          if (this.$store.getters.filter.date.start !== null && this.$store.getters.filter.date.end !== null) {
            let filterStart = moment(this.$store.getters.filter.date.start).utcOffset(this.$store.getters.outletSettings.timezone_offset).hour(0).format('YYYY-MM-DD')
            let filterEnd = moment(this.$store.getters.filter.date.end).utcOffset(this.$store.getters.outletSettings.timezone_offset).hour(0).format('YYYY-MM-DD')
            for (let i in product.times) {
              let time = moment(product.times[i].date).format('YYYY-MM-DD')
              if (product.times[i].available && (filterStart <= time && filterEnd >= time)) {
                return true
              }
            }
            return false
          }

        }

        return true
      }
    },
    computed: {
      products() {
        let items = []
        if (this.$store.getters.selectedCategory) {
          if (this.$store.getters.selectedCategory.id) {
            items = this.$store.getters.products[this.$store.getters.selectedCategory.id].items
          }
          if (this.$store.getters.selectedCategory.id === 0) {
            items = this.$store.getters.popularProducts.items
          }
        }

        items = items.filter(item => this.filtered(item))

        return items
      },
      parent() {
        if (!this.$store.getters.selectedCategory) {
          return null
        }
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].id === this.$store.getters.selectedCategory.parent_id) {
            return this.$store.getters.categories[i]
          }
        }
        return null
      },
      categories() {
        let parent = null
        if (this.$store.getters.selectedCategory) {
          parent = this.$store.getters.selectedCategory.id
        }
        let categories = []
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].parent_id === parent) {
            categories.push(this.$store.getters.categories[i])
          }
        }
        return categories
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>
  div.placeholder {
    width: 100%;
    height: 0;
    position: relative;
    border-radius: 16px;
  }
</style>
